// store/index.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import subscriptionReducer from "./slices/subscriptionSlice";
import sessionReducer from "./slices/sessionSlice";
import creditReducer from "./slices/creditSlice";
import paymentReducer from './slices/paymentSlice';

const loggerMiddleware = (store) => (next) => (action) => {
	console.log("Dispatching action:", action);
	console.log("State before action:", store.getState());
	const result = next(action);
	console.log("State after action:", store.getState());
	return result;
};

export const store = configureStore({
	reducer: {
		auth: authReducer,
		subscription: subscriptionReducer,
		sessions: sessionReducer,
		credits: creditReducer,
		payments: paymentReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				// Ignore Firebase Timestamp fields
				ignoredActionPaths: [
					"auth/setUser",
					"subscription/requestSubscription/rejected",
					"subscription/requestSubscription/fulfilled",
					'sessions.userSessions',
					'meta.arg',
					'payload.date',
					'subscription.data.startDate',
					'subscription.data',
					'credits.nextRenewal',
					'sessions.selectedDate',
					'sessions.userSessions.0.date',
					'sessions.userSessions.0.createdAt'
				],
				ignoredPaths: [
                    'payload.date',
                    'payload.createdAt',
                    'payload.updatedAt',
					"payment.pendingPayments.submittedAt",
					"auth.user.proactiveRefresh",
					"auth.user.stsTokenManager",
					"auth.user.reloadUserInfo",
					'sessions.list.date',
					"sessions.list.date",
					'subscription.data',
					'sessions.data.date',
					"subscription.data.createdAt",
					'subscription.data.startDate',
					"subscription.data.nextRenewal",
					'subscription.pendingRequest.createdAt',
					'meta.arg.proofFile',
					'payload.pendingRequest.createdAt',
					'credits.nextRenewal',
					'sessions.selectedDate',
					'sessions.userSessions.0.date',
					'sessions.userSessions.0.createdAt'
				],
			},
		}).concat(loggerMiddleware),
});
